import Super from 'client-portal/routes/-request/unavailable';
import classic from 'ember-classic-decorator';

@classic
export default class SiteRequestUnavailable extends Super {}
